
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.894 9.691v5.332l2.29 2.576V9.69L16.537 3H3.54l5.353 6.691zM2.11 2.812A.5.5 0 012.5 2h15.077a.5.5 0 01.39.812l-5.783 7.23v8.872a.5.5 0 01-.874.332l-3.29-3.7a.5.5 0 01-.126-.332v-5.172L2.11 2.812z","fill":"#303133"}})])
          )
        }
      }
    